import PageHero from '@/components/feature/PageHero';
import { strategyHero } from '@/mocks/strategy';

export default function StrategyHero() {
  return (
    <PageHero
      eyebrow={strategyHero.eyebrow}
      title={strategyHero.title}
      titleHighlight={strategyHero.subtitle}
      desc={strategyHero.desc}
      imageUrl="https://readdy.ai/api/search-image?query=Grand%20national%20strategy%20visualization%20with%20deep%20dark%20ink%20navy%20background%2C%20glowing%20golden%20and%20blue%20light%20streams%20forming%20a%20radiant%20star%20constellation%20over%20an%20abstract%20China%20map%20silhouette%2C%20eco%20green%20accent%20nodes%2C%20solemn%20dignified%20technological%20aesthetic%2C%20minimal%20clean%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1800&height=1100&seq=strategy-hero-01&orientation=landscape"
      imageAlt="国家战略 人工智能 数字乡村"
      imageTitle="国家战略 人工智能应用服务商"
    />
  );
}